import { GenericValue } from 'hisng';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-infoquelle',
    templateUrl: './with-datasource.component.html'
} )
export class InformationSourceFormComponent extends WithDatasourceComponent<GenericValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/jobapplication/value/jobapplicationinformationsource',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.informationSource',
            } );
    }

    set value( t: GenericValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.informationSource = t;
        }
    }

    get value(): GenericValue | undefined {
        return this.jobapplication?.informationSource;
    }

    getFieldValue( t?: GenericValue ): string | undefined {
        return t?.text;
    }
}
